/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);


const newsletterSub = Vue.resource('newsletters{/id}');

export default newsletterSub;




// WEBPACK FOOTER //
// ./src/resources/newsletterSub.js